// extracted by mini-css-extract-plugin
module.exports = {"xs":"LYSIcon_xs__4a218","sm":"LYSIcon_sm__b3beb","md":"LYSIcon_md__9e16f","xl":"LYSIcon_xl__f975e"};